import { TabsList as UITabsList, TabsTrigger } from "@/components/ui/tabs";
import { User, Palette, LayoutDashboard, BookOpen, Building2, CalendarClock } from "lucide-react";

interface TabsListProps {
  showClassesTab: boolean;
  showAdminTab: boolean;
  showScheduleTab: boolean;
  tabCount: number;
  userRole?: string;
}

export const TabsList = ({
  showClassesTab,
  showAdminTab,
  showScheduleTab,
  tabCount,
  userRole,
}: TabsListProps) => {
  return (
    <UITabsList className={`grid w-full grid-cols-${tabCount} bg-card p-1 rounded-xl`}>
      <TabsTrigger
        value="perfil"
        className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground rounded-lg transition-all duration-300"
      >
        <User className="mr-2 h-4 w-4" />
        Perfil
      </TabsTrigger>
      <TabsTrigger
        value="estilos"
        className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground rounded-lg transition-all duration-300 "
      >
        <Palette className="mr-2 h-4 w-4" />
        Estilos
      </TabsTrigger>
      {(showClassesTab && userRole !== 'manager') && (
        <TabsTrigger
          value="clases"
          className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground rounded-lg transition-all duration-300 setting-clase"
        >
          <BookOpen className="mr-2 h-4 w-4" />
          Clases
        </TabsTrigger>
      )}
      {showScheduleTab && (
        <TabsTrigger
          value="horarios"
          className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground rounded-lg transition-all duration-300"
        >
          <CalendarClock className="mr-2 h-4 w-4" />
          Horarios
        </TabsTrigger>
      )}
      {showAdminTab && (
        <TabsTrigger
          value="admin"
          className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground rounded-lg transition-all duration-300 setting-admin "
        >
          {userRole === "manager" ? (
            <Building2 className="mr-2 h-4 w-4" />
          ) : (
            <LayoutDashboard className="mr-2 h-4 w-4" />
          )}
          {userRole === "manager" ? "Gimnasio" : "Admin"}
        </TabsTrigger>
      )}
    </UITabsList>
  );
};
